<template>
    <!-- Componente para mostrar la cotización de BBVA -->
    <div class="bbva-quotation bg-light-blue py-8 mt-10 text-white">
        <h3 class="font-medium text-xl lg:text-2xl text-center px-4 leading-tight lg:leading-normal sm:mt-2">Resumen de
            tu Simulación BBVA Consumer Finance</h3>
        <div class="flex flex-col md:flex-row justify-around mt-8 md:mt-12 mb-8 px-10">
            <div class="text-center w-full md:w-1/3">
                <p class="font-medium">Plazo</p>
                <img
                    class="h-16 mt-6 mx-auto"
                    :src="`${url}/images/icons/speedometer_icon.png`"
                    alt="Velocimetro"
                >
                <p class="text-3xl mt-6">{{ instalments[instSelected] }} MESES</p>
                <p class="mt-6 text-lg">Tasa de Interés <span class="text-xs align-top">1</span> {{ tasa }}</p>
            </div>
            <div class="line hidden md:block border-solid border-l border-white h-48 lg:h-56 mt-2"></div>
            <div class="text-center w-full md:w-1/3 mt-6 md:mt-0">
                <p class="font-medium">Pago Mensual <span class="text-xs align-top">2</span></p>
                <img
                    class="h-16 mt-6 mx-auto"
                    :src="`${url}/images/icons/speedometer_icon.png`"
                    alt="Velocimetro"
                >
                <p class="text-3xl mt-6">${{ formatPrice(pagoMensual) }}</p>
                <p class="mt-6 text-lg">CAT {{ cat }}%</p>
                <p class="text-sm -mt-1">SIN IVA <span class="text-xs align-top">3</span></p>
            </div>
            <div class="line hidden md:block border-solid border-r border-white h-48 lg:h-56 mt-2"></div>
            <div class="text-center w-full md:w-1/3 mt-6 md:mt-0">
                <p class="font-medium">Financiamiento</p>
                <img
                    class="h-16 mt-6 mx-auto"
                    :src="`${url}/images/icons/speedometer_icon.png`"
                    alt="Velocimetro"
                >
                <p class="text-3xl mt-6">${{ formatPrice(financiamiento) }}</p>
                <div class="mt-4 text-lg leading-tight">
                    <p>Total a Pagar</p>
                    <p>${{ formatPrice(totalAPagar) }}</p>
                </div>
            </div>
        </div>
        <div class="bg-light-blue3 pt-4 pb-8 px-12 lg:px-20 mt-4">
            <p>¿Quieres incluir el Seguro de Auto en esta simulación?</p>
            <div class="flex mt-4">
                <label
                    class="radio-container"
                    :class="[includeInsurance !== 'insu' && incInsuDisabled ? ['opacity-75', 'cursor-default'] : 'cursor-pointer']"
                >
                    Sí
                    <input
                        type="radio"
                        name="includeInsurance"
                        :value="'insu'"
                        v-model="includeInsurance"
                        :disabled="incInsuDisabled"
                    >
                    <span class="radio-checkmark"></span>
                </label>
                <label
                    class="radio-container ml-12"
                    :class="[includeInsurance !== 'noInsu' && incInsuDisabled ? ['opacity-75', 'cursor-default'] : 'cursor-pointer']"
                >
                    No
                    <input
                        type="radio"
                        name="includeInsurance"
                        :value="'noInsu'"
                        v-model="includeInsurance"
                        :disabled="incInsuDisabled"
                    >
                    <span class="radio-checkmark"></span>
                </label>
            </div>
        </div>
        <div class="px-6 lg:px-20">
            <div class="text-center">
                <button
                    class="w-48 sm:w-88 hyundai-button sm:text-base mx-auto my-8"
                    @click="chargeBbvaForm()"
                >Revisa tu <span class="font-medium">Tabla de Pagos<br class="sm:hidden"> (Amortización)</span></button>
            </div>
            <div class="mt-2">
                <p>1. <span class="font-medium">Tasa de interés fija del {{ tasa }}% anual.</span></p>
                <p>2. El pago mensual no incluye IVA ni comisiones.</p>
                <p>3. <span class="font-medium">CAT {{ cat }}%</span> Sin IVA. Informativo. <span
                        class="font-medium">Fecha de cálculo:</span> {{ momentDate.format('DD/MM/YYYY') }}. <span
                        class="font-medium"
                    >Vigencia de la oferta:</span> {{ momentDate.format('DD/MM/YYYY') }}.</p>
            </div>
            <div class="mt-6 text-center">
                <p class="text-sm sm:text-base">Consulta términos, condiciones y requisitos de contratación del crédito
                    automotriz Consumer Finance en <a
                        class="underline"
                        href="https://www.bbva.mx/personas/productos/creditos/credito-auto.html"
                        target="_blank"
                    >BBVA.mx</a></p>
                <!-- <label class="checkbox-container ml-16">Acepto los Términos y condiciones de la Política de privacidad
                <input type="checkbox">
                <span class="checkmark"></span>
            </label> -->
            </div>
            <div class="text-center mt-6 text-sm">
                <p>Comisión por apertura 0.00% sobre el monto a financiar (pago único al inicio). El pago incluye un
                    Seguro de Vida, el cual subre el saldo insoluto del crédito en caso de fallecimiento. Si lo
                    contratas en BBVA su costo es de $4,200.00 financiados en el monto del crédito. Si decides
                    contratarlo con otra aseguradora deberá cumplir con las condiciones de cobertura y presentar la
                    póliza y el pago de la misma al momento de contratar el crédito. Aplican restricciones.</p>
                <!-- <p class="mt-2">Este documento es para efectos informativos y no constituye obligación u ofrecimiento formal por parte de BBVA Bancomer, S.A. en el otorgamiento del Crédito. Las condiciones de los Créditos estarán sujetas a cambios sin previo aviso.</p> -->
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    props: [
        "instalments",
        "instSelected",
        "bbvaQuotation",
        "versionId",
        "subsidiary",
        "isIframe",
    ],
    data() {
        return {
            // Variable para almacenar la url base del sitio
            url: $(".url").text(),
            // Variable para almacenar el slug del dealer correspondiente
            webpage: $(".webpage").text(),
            // Variable para determinar si mostrar o no la simulación
            // con el seguro de auto o no
            includeInsurance: "insu",
            // Variable para determinar si habilitar la opción
            // de incluir seguro de auto o no
            incInsuDisabled: true,
        };
    },
    watch: {
        // Determina si habilitar o no la opción de incluir
        // seguro de auto en la cotización y selecciona la
        // opción que esté disponible en la simulación
        instSelected: function (newVal) {
            if (newVal !== null) {
                this.includeInsurance = "insu";
                if (this.bbvaInstallments[this.term].success) {
                    if (!$.isEmptyObject(this.bbvaQuotation["noInsu"])) {
                        if (this.bbvaQuotation["noInsu"][this.term].success) {
                            this.incInsuDisabled = false;
                        } else {
                            this.incInsuDisabled = true;
                        }
                    } else {
                        this.incInsuDisabled = true;
                    }
                } else {
                    this.includeInsurance = "noInsu";
                    this.incInsuDisabled = true;
                    if (!this.bbvaInstallments[this.term].success) {
                        this.$emit("bad-instalment");
                    }
                }
            }
        },
        // bbvaQuotation: {
        //     handler: function(newVal) {
        //         if (!$.isEmptyObject(newVal.insu) && !$.isEmptyObject(newVal.noInsu)) {
        //             this.incInsuDisabled = false
        //         } else if (!$.isEmptyObject(newVal.insu)) {
        //             this.includeInsurance = 'insu'
        //         } else if (!$.isEmptyObject(newVal.noInsu)) {
        //             this.includeInsurance = 'noInsu'
        //         }
        //     },
        //     deep: true
        // },
    },
    methods: {
        // Función para dar formato a precios
        formatPrice(price) {
            return parseInt(price)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        },
        // Función para emitir un evento para mostrar
        // el formulario de BBVA y poder descargar la 
        // tabla de amortización
        chargeBbvaForm() {
            let quotData = {
                pagoMensual: this.pagoMensual,
                montoTotal: this.financiamiento,
                totalAPagar: this.totalAPagar,
                seguro: this.includeInsurance,
            };
            this.$emit("charge-bbva-form", quotData);
        },
    },
    computed: {
        // Variable para determinar el plazo de acuerdo
        // con el proporcionado en los props
        term() {
            let term = "";
            switch (this.instSelected) {
                case 0:
                    term = "t12";
                    break;
                case 1:
                    term = "t24";
                    break;
                case 2:
                    term = "t36";
                    break;
                case 3:
                    term = "t48";
                    break;
                case 4:
                    term = "t60";
                    break;
                case 5:
                    term = "t72";
                    break;
            }
            return term;
        },
        // Variables para extraer los datos necesarios para
        // mostrarlos en la cotización
        bbvaInstallments() {
            return this.bbvaQuotation[this.includeInsurance];
        },
        tasa() {
            if (!$.isEmptyObject(this.bbvaInstallments))
                return this.bbvaInstallments[this.term].success
                    ? this.bbvaInstallments[this.term].rates[0].unit.percentage
                    : 0;
            else return 0;
        },
        pagoMensual() {
            if (!$.isEmptyObject(this.bbvaInstallments))
                return this.bbvaInstallments[this.term].success
                    ? this.bbvaInstallments[this.term].installmentPlan
                        .installmentAmount.amount
                    : 0;
            else return 0;
        },
        cat() {
            if (!$.isEmptyObject(this.bbvaInstallments))
                return this.bbvaInstallments[this.term].success
                    ? this.bbvaInstallments[this.term].rates[1].unit.percentage
                    : 0;
            else return 0;
        },
        financiamiento() {
            if (!$.isEmptyObject(this.bbvaInstallments))
                return this.bbvaInstallments[this.term].success
                    ? this.bbvaInstallments[this.term].requestedAmount.amount
                    : 0;
            else return 0;
        },
        totalAPagar() {
            if (!$.isEmptyObject(this.bbvaInstallments))
                return this.bbvaInstallments[this.term].success
                    ? this.bbvaInstallments[this.term].totalAmount.amount
                    : 0;
            else return 0;
        },
        // Variable para contener una instancia de moment
        // y usarla en el componente
        momentDate() {
            return moment();
        },
    },
};
</script>

<style lang="scss">
.bbva-quotation {
    .radio-container {
        display: block;
        position: relative;
        padding-left: 2.5rem;
        /* margin-bottom: 12px; */
        // cursor: pointer;
        /* font-size: 22px; */
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default radio button */
    .radio-container input {
        position: absolute;
        opacity: 0;
        // cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom radio button */
    .radio-checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 1.5rem;
        width: 1.5rem;
        background-color: #ededed;
        // border-radius: 50%;
        // border: 1px solid #000;
    }

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .radio-checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    .radio-container input:checked~.radio-checkmark:after {
        display: block;
    }

    /* Style the indicator (dot/circle) */
    .radio-container .radio-checkmark:after {
        left: 7px;
        top: 1px;
        width: 10px;
        height: 18px;
        border: solid #00aad2;
        border-width: 0 4px 4px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
}
</style>